import _ from 'lodash';
import { DateTime } from 'luxon';
import React from 'react';

import { useGetEconomicIndexQuery } from 'generated/graphql';
import { StandardSourceMetricCard } from 'modules';



export interface IData {
  indexMetrics: StandardSourceMetricCard.StandardSourceMetricCardProps[];
}


export function useQuery() {
  const tuple = useGetEconomicIndexQuery({
    variables: {
      options: {
        filter: {
          economicIndex: [
            'ADXTNO',
            'CCSA',
            'CES0500000003',
            'CIVPART',
            'COMPQ',
            'CPIAUCSL',
            'CPILFESL',
            'CSUSHPISA',
            'DGORDER',
            'DGS1',
            'DGS10',
            'DGS1MO',
            'DGS2',
            'DGS20',
            'DGS3',
            'DGS30',
            'DGS3MO',
            'DGS5',
            'DGS6MO',
            'DGS7',
            'DPCCRV1Q225SBEA',
            'DSPIC96',
            'EXHOSLUSM495S',
            'GDP',
            'GDPA',
            'HOUST',
            'HPIPONM226S',
            'ICSA',
            'INDPRO',
            'JTSJOL',
            'LES1252881600Q',
            'MARTSSM44W72USS',
            'MEPAINUSA672N',
            'MORTGAGE30US',
            'OPHNFB',
            'PAYEMS',
            'PCE',
            'PCEPI',
            'PCEPILFE',
            'PERMIT',
            'PPIACO',
            'PSAVERT',
            'RSAFS',
            'SPX',
            'TCU',
            'U6RATE',
            'UMCSENT',
            'UNRATE',
            'USSTHPI',
            'WHLSLRIMSA',
            'WPSFD4131',
            'WPUFD49207'
          ],
          years: DateTime.now().month === 1
            ? _.times(2, (i) => DateTime.now().year - i)
            : [DateTime.now().year]
        }
      }
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        indexMetrics: tuple.data?.economicIndices.map((index): StandardSourceMetricCard.StandardSourceMetricCardProps => {
          return {
            name: index.displayName ?? '',
            value: index.mostRecentValue,
            displayUnit: index.displayUnit,
            changeDisplayUnit: index.changeDisplayUnit,
            upIsGood: index.upIsGood,
            changeMoM: index.mostRecentChange ?? null,
            fredCode: index.fredCode,
            fredUrl: index.fredUrl ?? '',
            updateFrequency: index.updateFrequency.name
          };
        }) ?? []
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
